// Destaca a(s) ocorrencia(s) do termo pesquisado dentro de um texto (usado em
// Contas e Contactos para dar feedback visual imediato de onde o termo bateu).
function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function HighlightText({ text, query, className = "" }) {
  const value = text == null ? "" : String(text);
  const q = (query || "").trim();
  if (!q) return value || null;
  const re = new RegExp(`(${escapeRegExp(q)})`, "i");
  const parts = value.split(re);
  if (parts.length <= 1) return value || null;
  // String.split com grupo de captura alterna [fora-do-match, match, fora-do-match, match, ...]
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1
          ? <mark key={i} className={`bg-amber-200 text-navy rounded-sm px-0.5 ${className}`}>{part}</mark>
          : <span key={i}>{part}</span>
      )}
    </>
  );
}
